<div class="_dialog-title">
  <input class="country-search" [(ngModel)]="searchCriteria" type="text" [placeholder]="data.searchPlaceholder + '...'" (click)="$event.stopPropagation()" />
  <button mat-icon-button (click)="cancel()" class="dialog-close-button">
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>

<div class="_dialog-content">
  @if (!searchCriteria) {
    @for (country of data.preferredCountriesInDropDown; track country) {
      <button type="button" class="country-list-button" (click)="onCountrySelect(country)">
        <div class="icon-wrapper">
          <div class="flag" [ngClass]="country.flagClass"></div>
        </div>
        <div class="label-wrapper">
          {{ country.name }}
          @if (country?.dialCode) {
            <span>+{{ country.dialCode }}</span>
          }
        </div>
      </button>
    }
    @if (data.preferredCountriesInDropDown?.length) {
      <mat-divider></mat-divider>
    }
  }
  @for (country of data.allCountries; track country) {
    @if (country | search: searchCriteria) {
      <button type="button" class="country-list-button" (click)="onCountrySelect(country)">
        <div class="icon-wrapper">
          <div class="flag" [ngClass]="country.flagClass"></div>
        </div>
        <div class="label-wrapper">
          {{ country.name }} +{{ country.dialCode }}
        </div>
      </button>
    }
  }
</div>

